import React from "react";
import {
  DcaTime,
  DcaType,
  DcaTypeName,
  DcaTypePercentage,
  Frequencies,
  FrequencyValues,
  WeekTime,
  WeekTimeName,
  BotTypeName,
  TakeProfitType,
  TakeProfitTypeName
} from "../../../Const";
import { Row, Table } from "react-bootstrap";
import {
  capitalize,
  getKeyByValue,
  getMonthDay,
  isLong,
} from "../../../utils/Utils";

const DcaBotSetting = (props) => {
  const { bot,t } = props;
  const exchangePair = bot.exchange_pair || {};
  const exchange = exchangePair.exchange || {};
  const pair = exchangePair.pair || {};
  const indicators = bot.bot_indicators || [];
  const dcaSetting = bot.dca_setting || {};
  const limitOrder = bot.extra_order_percentage || 0;
  const initFund = bot.initial_fund || 0;
  let dcaType = dcaSetting.entry_type || DcaType.time;
  if (dcaType === DcaTypePercentage) {
    dcaType = isLong(bot.strategy) ? DcaType.buyDown : DcaType.sellUp;
  }
  const tps = bot.tps || [];
  let takeProfit = (bot.profit || 0).toFixed(2) + "%";
  if (tps.length) {
    takeProfit =
    tps[0].tp_type === TakeProfitType.fixedTP
        ? TakeProfitTypeName.fixedTP
        : TakeProfitTypeName.variableTP;
  }

  const dcaTypeName = DcaTypeName[getKeyByValue(DcaType, dcaType)];
  let dcaSettingHead;
  let dcaSettingValue;
  let martingale;
  switch (dcaType) {
    case DcaType.time:
      dcaSettingHead = (
        <>
          <th>Time Buy</th>
        </>
      );
      let time = dcaSetting.value;
      if (time === DcaTime.weekly) {
        time =
          "Every " + WeekTimeName[getKeyByValue(WeekTime, dcaSetting.value2)];
      } else if (time === DcaTime.monthly) {
        time = "Every " + getMonthDay(dcaSetting.value2) + " of month";
      } else {
        time = capitalize(time);
      }
      dcaSettingValue = (
        <>
          <td>{time}</td>
        </>
      );
      break;
    case DcaType.indicator:
      const entryIndicators =
        indicators &&
        indicators
          .filter((item) => item.type == "entry")
          .map((item) => item.name)
          .join(", ");
      const frequency =
        Frequencies[getKeyByValue(FrequencyValues, bot.frequency)];
      martingale =
        dcaSetting.value3 == 0 ? "Disabled" : dcaSetting.value3 + "%";
      dcaSettingHead = (
        <>
          <th>{t("indicators")}</th>
          <th>{t("frequency")}</th>
          <th>{t("martingale")}</th>
        </>
      );
      dcaSettingValue = (
        <>
          <td>{entryIndicators}</td>
          <td>{frequency}</td>
          <td>{martingale}</td>
        </>
      );
      break;
    case DcaType.buyDown:
    case DcaType.sellUp:
      let side = dcaType === DcaType.buyDown ? "Buy" : "Sell";
      martingale =
        dcaSetting.value3 == 0 ? "Disabled" : dcaSetting.value3 + "%";
      dcaSettingHead = (
        <>
          <th>{t("trigger-price")}</th>
          <th>{t("subsequent")} {side}</th>
          <th>Martingale</th>
        </>
      );

      dcaSettingValue = (
        <>
          <td>
            {dcaSetting.value} {pair.to}
          </td>
          <td>{dcaSetting.value2}%</td>
          <td>{martingale}</td>
        </>
      );
      break;
    default:
      break;
  }

  return (
    <Row>
      <Table responsive>
        <thead>
          <tr>
            <th>{t("exchange")}</th>
            <th>{t("pair")}</th>
            <th>{t("bot-type")}</th>
            <th>{t("fund")}</th>
            <th>{t("ord-am")}</th>
            <th>DCA Type</th>
            {dcaSettingHead}
            <th>{t("no-of-ord")}</th>
            <th>{t("tp")}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div>
                <img
                  src={exchange.image}
                  width={20}
                  height={20}
                  style={{ marginRight: 10 }}
                />
                <span style={{ fontWeight: "bold" }}>{exchange.name}</span>
              </div>
            </td>
            <td>{pair && `${pair.from}/${pair.to}`}</td>
            <td>{bot && BotTypeName[bot.type]}</td>
            <td>{initFund == 0 ? t("no-limit") : initFund + " " + pair.to}</td>
            <td>
              {bot.base_order_percentage} {pair.to}
            </td>
            <td>{dcaTypeName}</td>
            {dcaSettingValue}
            <td>{limitOrder === 0 ? t("no-limit") : limitOrder}</td>
            <td>{takeProfit}</td>
          </tr>
        </tbody>
      </Table>
    </Row>
  );
};

export default DcaBotSetting;
